var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row chartArea"},[_c('div',{staticClass:"col-xl-12 col-lg-6 innerBox",style:({ padding: '5px' })},[_c('div',{staticClass:"col-xl-12 mixChart"},[_c('mix-chart',{ref:"chart",style:({ height: '100%', padding: '15px' }),attrs:{"chartData":_vm.mixChartData.data,"options":_vm.mixChartData.options}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }